import Env from "../environments";

export const embedTrackFoe = () => {
  if (Env.DUTY_CAST_TRACKING_URL) {
    const script = document.createElement("script");
    script.src = Env.DUTY_CAST_TRACKING_URL + "&bt=" + Env.DUTY_CAST_BUILD_TIMESTAMP;
    script.async = true;
    document.body.appendChild(script);
  }
}

export const embedGoogleTag = () => {
  if (Env.DUTY_CAST_GOOGLE_TAG_KEY) {
    window.$("head").append(window.$(
      `
    <!-- Google Tag Manager -->
    <script>(function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', '${Env.DUTY_CAST_GOOGLE_TAG_KEY}');</script>
    <!-- End Google Tag Manager -->
    `
    ));
    window.$("body").prepend(window.$(
      `
    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${Env.DUTY_CAST_GOOGLE_TAG_KEY}"
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    </noscript>
    <!-- End Google Tag Manager (noscript) -->
    `
    ));
  }
}

export const embedGoogleAnalytic = () => {
  if (Env.DUTY_CAST_GOOGLE_ANALYTIC_KEY) {
    window.$("head").append(window.$(
      `
    <!-- Global site tag (gtag.js) - Google Analytics -->
    <script async
      src="https://www.googletagmanager.com/gtag/js?id=${Env.DUTY_CAST_GOOGLE_ANALYTIC_KEY}"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', '${Env.DUTY_CAST_GOOGLE_ANALYTIC_KEY}');
    </script>
    `
    ));
  }
}

export const embedAllTrack = () => {
  embedGoogleTag();
  embedGoogleAnalytic();
  embedTrackFoe();
}